module.exports = __webpack_public_path__ + "landing_slider_second_slide_376x627.becc437.jpg";